module.exports = __webpack_public_path__ + "static/media/Ekans_gaussian2.18284b80.png";